import React, { Component } from 'react';
import axios from 'axios';

import Header from '../common/layout/header'; 
import Footer from '../common/layout/footer';
import Loader from '../common/loader';

import { Link, Navigate } from "react-router-dom";
import { BaseUrl } from '../common/config';

import Cartitem1 from '../assets/images/pcart-item-1.jpg';
import Cartitem2 from '../assets/images/pcart-item-2.jpg';
import Cartitem3 from '../assets/images/pcart-item-3.jpg';
import Cartitem4 from '../assets/images/pcart-item-4.jpg';
import banImg from '../assets/images/banner-img.jpg';
import banImgLeft from '../assets/images/banner-img01.jpg';
import banImgRight from '../assets/images/banner-img02.jpg';
import banNewProduct from '../assets/images/banner-new-product.jpg';

class Home extends Component {

    constructor(props) {
        super(props);
        this.state = {
          caegories:[],
          loading: true,
          offerProductData: [],
          pdflistData: [],
        };

        if(!localStorage.getItem("isLoggedIn"))
        window.location.href = '/';
    }

    componentDidMount(){

        this.offerProduct();
        this.pdflist();

        var timeInterval = '2000';
        this.setState({loading: true});

        var current = this;
        var myInterval = setInterval(function() {
            timeInterval = '';
            current.setState({loading: false});
            clearInterval(myInterval);
          },timeInterval);
    }

    pdflist(){

      this.setState({ loading: true });

      var loginDetails = {};
        if (localStorage.getItem('authData')) {
        loginDetails = JSON.parse(localStorage.getItem('authData'));
        }
          
      let URL = BaseUrl + "/listpdf";

      axios.get(URL, {headers: {"Auth-Token": loginDetails.token}}).then(async (response) => {

       let responseData = response.data.data[0];

       //console.log(responseData, 'responseData');

       this.setState({ pdflistData: responseData});


    });

  }


    offerProduct(){

     this.setState({ loading: true });

      var loginDetails = {};
        if (localStorage.getItem('authData')) {
        loginDetails = JSON.parse(localStorage.getItem('authData'));
        }


     let URL = BaseUrl + "offerlist";
     axios.get(URL, {headers: {"Auth-Token": loginDetails.token}}).then(async (response) => {

        let responseData = response.data.data[0];

        if(response.data.data.length > 0 && response.data.data.length == '1'){

        let responseDataFour = response.data.data[0];
        var list1 = responseDataFour.freeProductToAdd;
            list1 = list1.split(',');

        var combineArray = list1;
        var offerlist1 = responseDataFour.productToBeAdded;
            offerlist1 = offerlist1.split(',');
        var combineOfferArray = offerlist1;  

        var duplicateArrayRemove = combineArray.filter((item,
        index) => combineArray.indexOf(item) === index);

        var duplicateArrayRemoveOffer = combineOfferArray.filter((item,
        index) => combineOfferArray.indexOf(item) === index);

        this.setState({ offerproducts: responseDataFour, offerCombineProducts: duplicateArrayRemoveOffer, offerCombineFreeProducts: duplicateArrayRemove, freeProductDataFour: list1, freeProductDataFive: []}, function(){

            this.offerProductData(duplicateArrayRemoveOffer);
        });

     }else{

        let responseDataFour = response.data.data[0];
        let responseDataFive = response.data.data[1];
        var combineArray = [];

        var list1 = responseDataFour.freeProductToAdd;
            list1 = list1.split(',');

        var list2 = responseDataFive.freeProductToAdd;
            list2 = list2.split(',');

         combineArray = list1.concat(list2);

        var offerlist1 = responseDataFour.productToBeAdded;
            offerlist1 = offerlist1.split(',');
        var offerlist2 = responseDataFive.productToBeAdded;
            offerlist2 = offerlist2.split(',');
        var combineOfferArray = offerlist1.concat(offerlist2);  


        var duplicateArrayRemove = combineArray.filter((item,
        index) => combineArray.indexOf(item) === index);

        var duplicateArrayRemoveOffer = combineOfferArray.filter((item,
        index) => combineOfferArray.indexOf(item) === index);

        this.setState({ offerproducts: responseData, offerCombineProducts: duplicateArrayRemoveOffer, offerCombineFreeProducts: duplicateArrayRemove, freeProductDataFour: list1, freeProductDataFive: list2}, function(){
            this.offerProductData(duplicateArrayRemoveOffer);
        });
     }


     }).catch((err) => {
        console.log(err);
     });

    }


    offerProductData(responseData){

        var offerproductsList = responseData;
        this.setState({ loading: true });
        let authData = { accountPriceListId: "" };
        authData = JSON.parse(localStorage.getItem('authData'));
        let productsId = { "$in": offerproductsList };
        let payload = {
            productIds: productsId,
            priceband: localStorage.getItem('priceband')
        }

        var loginDetails = {};
        if (localStorage.getItem('authData')) {
            loginDetails = JSON.parse(localStorage.getItem('authData'));
        }
        
        let URL = BaseUrl + "productsbyids";
        axios.post(URL, payload, {headers: {"Auth-Token": loginDetails.token}}).then(async (response) => {
            let responseData = response.data.data;

            //console.log(responseData, 'responseData');

            if(responseData.length > 0){

                localStorage.setItem('specialofferdisplay', 'Yes');

            }else{

                localStorage.setItem('specialofferdisplay', 'No');
            }

            this.setState({ offerProductData: responseData, loading: false});
        }).catch((err) => {
            console.log(err);
            this.setState({ loading: false, offerProductData: []})
        });
    }

    // getProductCategories()
    // {
    //     let URL =  "http://localhost:3000/api/category";
    //     axios.get(URL).then((response)=>{
    //     this.state.caegories.push(response.data.data);
    //     }).catch((err)=>{
    //         console.log(err);
    //     })
    // }

    redirectUrl(){

      window.location.href = '/offerinfo';
    }

    render(){
        
        return(
            <>
                <Header/>
                    {!this.state.loading &&
                    <main className='main-section'>
                    <section className="cart-block">
                        <div className="sm-container">

                            <div className="cart-flx">
                                <div className="cart-item">
                                    <Link className="cart-innr" to="/checkout/pizza">
                                        <div className="cart-top">
                                            <p>PIZZA</p>
                                        </div>
                                        <div className="cart-bottom">
                                            <p>
                                                ORDER NOW
                                            </p>
                                        </div>
                                        <img src={Cartitem1} className="cart-back" alt="Cart" />
                                    </Link>
                                </div>
                                <div className="cart-item">
                                <Link className="cart-innr" to="/checkout/pasta-rice-noodle-sauces">
                                        <div className="cart-top">
                                            <p>PASTA, RICE & NOODLE SAUCES</p>
                                        </div>
                                        <div className="cart-bottom">
                                            <p>
                                                ORDER NOW
                                            </p>
                                        </div>
                                        <img src={Cartitem2} className="cart-back" alt="Cart" />
                                    </Link>
                                </div>
                                <div className="cart-item">
                                <Link className="cart-innr" to="/checkout/burrito">
                                        <div className="cart-top">
                                            <p>BURRITO</p>
                                        </div>
                                        <div className="cart-bottom">
                                            <p>
                                                ORDER NOW
                                            </p>
                                        </div>
                                        <img src={Cartitem3} className="cart-back" alt="Cart" />
                                    </Link>
                                </div>
                                <div className="cart-item">
                                    <Link className="cart-innr" to="/categories">
                                        <div className="cart-top">
                                            <p>PRODUCTS INFO</p>
                                        </div>
                                        <div className="cart-bottom">
                                            <p>
                                                NUTRITIONAL / ALLERGEN INFO & PREP GUIDES
                                            </p>
                                        </div>
                                        <img src={Cartitem4} className="cart-back" alt="Cart" />
                                    </Link>
                                </div>
                            </div>

                 {this.state.pdflistData == undefined && this.state.offerProductData.length > 0 && 
                       <div className='home-banner' onClick={this.redirectUrl.bind(this)}>
                            <div className='ban-wrap'>
                                <div className='ban-left'>
                                    <div className='ban-img'>
                                        <img src={banImg} className="banImg" alt="Banner"/>
                                    </div>
                                    <div className='ban-left-text'>
                                        <h3>Offers<span>for you</span></h3>
                                    </div>
                                </div>
                                <div className='ban-right'>
                                    <div className='ban-right-text'>
                                        <p>Explore FREE Products exclusively for you <span>(Pasta, Rice & Noodles)!</span></p>
                                    </div>
                                    <div className='ban-right-btn'>
                                        <a className='button' onClick={this.redirectUrl.bind(this)} >Click Here</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                    {this.state.pdflistData !== '' && this.state.pdflistData !== undefined && this.state.offerProductData.length > 0 && 

                        <div className='hm-banner-wrap'>
                            <div className='hm-left-ban' onClick={this.redirectUrl.bind(this)}>
                                <div className='hm-ban-img'>
                                    <img src={banImgLeft} className="banImg" alt="Banner"/>
                                </div>
                                <div className='hm-ban-content'>
                                    <div className='ban-left-text'>
                                        <span className='ofr-icon'></span>
                                        <h3>Offers <span>For You</span></h3>
                                    </div>
                                    <div className='ban-right-text'>
                                        <p>Explore FREE Products exclusively for you <span>(FREE Pasta / FREE Rice)!</span></p>
                                    </div>
                                    <div className='ban-right-btn'>
                                        <a className='button' onClick={this.redirectUrl.bind(this)}>Click Here</a>
                                    </div>
                                </div>
                            </div>
                       
                            <div className='hm-right-ban'>
                               <a target="_blank"  href={BaseUrl + this.state.pdflistData.path}>
                                <div className='hm-ban-img'>
                                <img src={banImgRight} className="banImg" alt="Banner"/>
                                </div>
                                <div className='hm-ban-content'>
                                    <div className='ban-right-text'>
                                        <h3>{this.state.pdflistData.PDFTitle}</h3>
                                    </div>
                                    <div className='ban-right-btn'>
                                        <a className='button' target="_blank" href={BaseUrl + this.state.pdflistData.path}>Click Here</a>
                                    </div>
                                </div>
                                </a>
                            </div>
                        
                           </div>

                         }

                        {this.state.pdflistData !== '' && this.state.pdflistData !== undefined && this.state.offerProductData.length == 0 && 
                        <div className='hm-right-ban full-width'>
                           <a target="_blank"  href={BaseUrl + this.state.pdflistData.path}>
                            <div className='hm-ban-img'>
                                <img src={banNewProduct} className="banImg" alt="Banner"/>
                            </div>
                            <div className='hm-ban-content'>
                                <div className='ban-right-text'>
                                    <h3>{this.state.pdflistData.PDFTitle}</h3>
                                </div>
                                <div className='ban-right-btn'>
                                    <a className='button' target="_blank" href={BaseUrl + this.state.pdflistData.path}>Click Here</a>
                                </div>
                            </div>
                            </a>
                        </div> }

                      </div>
                    </section>
                    </main>

                   }

                    {/* Loader & Popup START */}
                    <div className="common">
                        
                        {/* <Alert extractId="success" customContent="Cart Added Success" /> */}

                    </div>

                    {this.state.loading && <main className='main-section'><Loader propsClassName="load-lag" /> </main>}

                    {/* Loader & Poupp END */}

                            <Footer/>
              
            </>
        );
    }
}

export default Home;